export const LOGGED_OUT_MODAL_BODY_MESSAGES = {
	ACCOUNT_MERGED: 'You have been signed out because you signed in on another device.',
	ACCOUNT_DELETED: 'This account has been deleted on another device.'
};

export const LOGGED_OUT_MODAL_BUTTON_PROPERTIES = {
	CLOSE: { TEXT: 'Close', ACTION: 'signOutAndClose' },
	SIGN_IN_AGAIN: { TEXT: 'Sign In Again', ACTION: 'signOutAndRedirectToSignIn' },
	SIGN_UP_AGAIN: { TEXT: 'Sign Up Again', ACTION: 'signOutAndRedirectToSignUp' }
};